/**
 * Generated by orval v6.16.0 🍺
 * Do not edit manually.
 * Booking API
 * API for the booking site

 * OpenAPI spec version: 0.1.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
  UseQueryOptions,
  QueryFunction,
  UseQueryResult,
  QueryKey,
} from '@tanstack/react-query';
import type { PracticeAvailabilityResponseResponse, GetPracticeAvailabilityParams } from './models';
import { customInstance } from '../core/customInstance';
import type { ErrorType } from '../core/customInstance';

// eslint-disable-next-line
type SecondParameter<T extends (...args: any) => any> = T extends (
  config: any,
  args: infer P,
) => any
  ? P
  : never;

/**
 * Gets the available appointment slots for providers in the specified practice
based on the practice / provider settings.

 * @summary Get upcoming availabilities for practice
 */
export const getPracticeAvailability = (
  practiceId: number,
  params?: GetPracticeAvailabilityParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<PracticeAvailabilityResponseResponse>(
    {
      url: `/book/api/${practiceId}/availabilities/practice-availabilities`,
      method: 'get',
      params,
      signal,
    },
    options,
  );
};

export const getGetPracticeAvailabilityQueryKey = (
  practiceId: number,
  params?: GetPracticeAvailabilityParams,
) =>
  [
    `/book/api/${practiceId}/availabilities/practice-availabilities`,
    ...(params ? [params] : []),
  ] as const;

export const getGetPracticeAvailabilityQueryOptions = <
  TData = Awaited<ReturnType<typeof getPracticeAvailability>>,
  TError = ErrorType<unknown>,
>(
  practiceId: number,
  params?: GetPracticeAvailabilityParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getPracticeAvailability>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  },
): UseQueryOptions<Awaited<ReturnType<typeof getPracticeAvailability>>, TError, TData> & {
  queryKey: QueryKey;
} => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPracticeAvailabilityQueryKey(practiceId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPracticeAvailability>>> = ({
    signal,
  }) => getPracticeAvailability(practiceId, params, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!practiceId, ...queryOptions };
};

export type GetPracticeAvailabilityQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPracticeAvailability>>
>;
export type GetPracticeAvailabilityQueryError = ErrorType<unknown>;

/**
 * @summary Get upcoming availabilities for practice
 */
export const useGetPracticeAvailability = <
  TData = Awaited<ReturnType<typeof getPracticeAvailability>>,
  TError = ErrorType<unknown>,
>(
  practiceId: number,
  params?: GetPracticeAvailabilityParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getPracticeAvailability>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetPracticeAvailabilityQueryOptions(practiceId, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};
